//@flow

import * as React from 'react';
import styled from 'styled-components';

const StyledTextArea = styled.textarea`
  width: inherit;
  margin: 0 0 5px 0;
  border: solid;
  border-width: 2px;
  border-color: ${props => props.invalid ? '#e47d7d' : '#e1e1e1'};
  border-radius: 4px;
  color: #333333;
  font-weight: 500;
  font-family: "Open Sans",sans-serif;
  line-height: 16px;
  padding: 5px;

  :focus{
    border-color: #7dafe4;
    background-color: #ffffff;
    outline-style:none;
    background-color:transparent;
  }
  :disabled {
    background-color: #f1f1f1;
  }
  :-webkit-autofill {
    -webkit-box-shadow: 0 0 0 100px white inset;
  }
`;

const TextArea = (props: any): React.Node => (
  <StyledTextArea
    {...props}
    innerRef={(node) => { this.domNode = node }}
    tabIndex="0"
  />
);

export default TextArea;



// WEBPACK FOOTER //
// ./src/components/TextArea.jsx